import { useState } from 'react';
import { useScrollAnimation } from '@/hooks/useScrollAnimation';

const courses = [
  {
    id: 'meta',
    icon: 'ri-global-line',
    color: '#00FF88',
    title: '元宇宙系统课',
    subtitle: 'Metaverse Mastery',
    tag: '旗舰课程',
    tagColor: '#00FF88',
    duration: '120课时',
    level: '入门→精通',
    img: 'https://public.readdy.ai/ai/img_res/503968f1b732011b8350995cd72da612.jpg',
    why: '元宇宙是未来20年最重要的技术革命，掌握元宇宙将让你在数字经济时代占据先机。',
    whatLearn: ['元宇宙底层架构与技术栈', 'XR沉浸体验设计与开发', '数字孪生建模与应用', '元宇宙经济模型与商业化', 'Web5.0协议与去中心化身份', '元宇宙内容创作与IP运营'],
    career: ['元宇宙产品经理', '虚拟世界设计师', '数字孪生工程师', '元宇宙投资分析师'],
    future2030: '2030年元宇宙相关岗位将超过5000万个，薪资溢价达300%',
    future2040: '2040年元宇宙将成为主要经济形态，相关从业者将主导数字文明建设',
    future2050: '2050年元宇宙与物理世界完全融合，元宇宙架构师将成为最重要的职业之一',
    relations: ['6G网络', 'AI', '区块链', 'XR技术', '量子计算', '脑机接口'],
    modules: [
      { title: '模块一：元宇宙底层逻辑', lessons: 20, desc: '从哲学到技术，深度解析元宇宙的本质、底层架构与演化路径' },
      { title: '模块二：XR技术全栈', lessons: 25, desc: 'VR/AR/MR/XR设备原理、开发框架、交互设计与性能优化' },
      { title: '模块三：数字孪生工程', lessons: 18, desc: '从传感器到渲染引擎，构建城市级数字孪生系统的完整工程路径' },
      { title: '模块四：元宇宙经济学', lessons: 22, desc: 'NFT、虚拟地产、创作者经济、DeFi在元宇宙中的应用与商业模式' },
      { title: '模块五：Web5.0协议', lessons: 15, desc: 'DID去中心化身份、数据主权、跨链互操作的技术实现' },
      { title: '模块六：综合项目实战', lessons: 20, desc: '从零构建一个完整的元宇宙应用，包含XR体验、数字资产与社交功能' },
    ],
  },
  {
    id: 'bci',
    icon: 'ri-mental-health-line',
    color: '#A855F7',
    title: '脑机接口课',
    subtitle: 'Brain-Computer Interface',
    tag: '前沿科技',
    tagColor: '#A855F7',
    duration: '80课时',
    level: '进阶',
    img: 'https://readdy.ai/api/search-image?query=brain%20computer%20interface%20neural%20link%20glowing%20purple%20neon%20neural%20network%20connections%20human%20brain%20digital%20signals%20futuristic%20technology%20education%20dark%20background%20vibrant%20colorful&width=600&height=340&seq=course-bci-v2&orientation=landscape',
    why: '脑机接口是人机交互的终极形态，2030年将成为价值万亿的产业，现在学习将让你成为这个领域的先行者。',
    whatLearn: ['神经科学基础与脑电信号原理', '非侵入式BCI设备工作原理', '神经信号采集与处理算法', 'BCI在医疗康复中的应用', 'BCI与元宇宙的融合路径', '脑机接口伦理与法律框架'],
    career: ['神经工程师', 'BCI产品设计师', '神经康复专家', '脑机接口研究员'],
    future2030: '2030年BCI设备消费级普及，相关工程师薪资将是传统软件工程师的5倍',
    future2040: '2040年脑机接口成为标配，意识工程师将成为最稀缺的职业',
    future2050: '2050年意识上传技术成熟，脑机接口专家将主导人类意识数字化的伦理与技术标准',
    relations: ['元宇宙', 'AI', '量子计算', '医疗科技', 'XR技术'],
    modules: [
      { title: '模块一：神经科学基础', lessons: 15, desc: '大脑结构、神经元工作原理、脑电波类型与认知神经科学入门' },
      { title: '模块二：BCI硬件系统', lessons: 18, desc: '电极阵列、信号放大器、A/D转换器的工作原理与选型指南' },
      { title: '模块三：信号处理算法', lessons: 20, desc: '时频分析、机器学习分类、深度学习在BCI中的应用' },
      { title: '模块四：BCI应用开发', lessons: 15, desc: '医疗康复、游戏控制、元宇宙交互的BCI应用开发实战' },
      { title: '模块五：伦理与未来', lessons: 12, desc: '脑机接口的伦理争议、隐私保护、法律框架与未来展望' },
    ],
  },
  {
    id: 'starlink',
    icon: 'ri-signal-tower-fill',
    color: '#00FFCC',
    title: '星链与低空经济',
    subtitle: 'Starlink & Low-Altitude Economy',
    tag: '新兴赛道',
    tagColor: '#00FFCC',
    duration: '60课时',
    level: '入门→进阶',
    img: 'https://readdy.ai/api/search-image?query=starlink%20satellite%20constellation%20low%20altitude%20economy%20eVTOL%20flying%20car%20urban%20air%20mobility%20teal%20cyan%20neon%20glow%20futuristic%20technology%20dark%20background%20vibrant%20colorful&width=600&height=340&seq=course-starlink-v2&orientation=landscape',
    why: '星链卫星互联网与低空经济（eVTOL/无人机）是未来10年最确定的万亿级赛道，中国已将低空经济列为国家战略。',
    whatLearn: ['卫星互联网技术架构与星链原理', 'eVTOL飞行汽车技术与市场', '低空空域管理与法规', '无人机商业应用与运营', '低空经济商业模式设计', '星链与6G的协同发展'],
    career: ['低空经济分析师', 'eVTOL产品经理', '无人机运营专家', '卫星互联网工程师'],
    future2030: '2030年低空经济规模突破2万亿，eVTOL商业运营在主要城市全面铺开',
    future2040: '2040年空中出行成为日常，低空经济从业者将超过1000万',
    future2050: '2050年太空旅游商业化，星际经济成为新的增长极',
    relations: ['6G网络', '元宇宙', 'AI', '量子通信', '新能源'],
    modules: [
      { title: '模块一：卫星互联网基础', lessons: 12, desc: '轨道力学、卫星通信原理、星链架构与全球覆盖策略' },
      { title: '模块二：eVTOL技术解析', lessons: 15, desc: '电动垂直起降原理、电池技术、自动驾驶与安全系统' },
      { title: '模块三：低空空域管理', lessons: 10, desc: '空域分层管理、UTM系统、国内外法规对比与合规指南' },
      { title: '模块四：商业模式设计', lessons: 13, desc: '低空物流、空中出行、农业无人机的商业模式与盈利路径' },
      { title: '模块五：投资与创业', lessons: 10, desc: '低空经济投资逻辑、创业机会识别与商业计划书撰写' },
    ],
  },
  {
    id: 'blockchain',
    icon: 'ri-links-line',
    color: '#FFD700',
    title: '区块链与Web3',
    subtitle: 'Blockchain & Web3',
    tag: '核心技术',
    tagColor: '#FFD700',
    duration: '90课时',
    level: '入门→精通',
    img: 'https://readdy.ai/api/search-image?query=blockchain%20network%20nodes%20glowing%20yellow%20gold%20neon%20connections%20decentralized%20web3%20cryptocurrency%20digital%20economy%20dark%20background%20vibrant%20colorful%20doodle%20art%20style&width=600&height=340&seq=course-blockchain-v2&orientation=landscape',
    why: '区块链是数字经济的基础设施，Web3是互联网的下一个形态。掌握区块链将让你在去中心化经济时代占据核心位置。',
    whatLearn: ['区块链底层原理与共识机制', '智能合约开发（Solidity/Rust）', 'DeFi协议设计与安全审计', 'NFT技术与数字资产经济', 'Web3应用开发全栈', 'DAO治理与代币经济学'],
    career: ['区块链工程师', 'DeFi协议设计师', 'Web3产品经理', '数字资产分析师'],
    future2030: '2030年Web3经济规模超过50万亿，区块链工程师将成为最稀缺的技术人才',
    future2040: '2040年去中心化金融超越传统金融，区块链成为全球经济基础设施',
    future2050: '2050年数字资产与物理资产完全互通，区块链架构师主导全球价值流通体系',
    relations: ['元宇宙', 'AI', '量子计算', '数字经济', 'Web5.0'],
    modules: [
      { title: '模块一：区块链原理', lessons: 18, desc: '哈希函数、Merkle树、共识机制（PoW/PoS/DPoS）的深度解析' },
      { title: '模块二：智能合约开发', lessons: 22, desc: 'Solidity语言、EVM原理、合约安全审计与最佳实践' },
      { title: '模块三：DeFi协议设计', lessons: 20, desc: 'AMM、借贷协议、收益聚合器的设计原理与实现' },
      { title: '模块四：NFT与数字资产', lessons: 15, desc: 'ERC-721/1155标准、NFT市场机制、数字版权与IP运营' },
      { title: '模块五：Web3全栈开发', lessons: 15, desc: 'ethers.js、wagmi、The Graph的Web3前端开发实战' },
    ],
  },
  {
    id: 'ai',
    icon: 'ri-robot-line',
    color: '#FF6B9D',
    title: 'AI与超级智能',
    subtitle: 'AI & Superintelligence',
    tag: '最热赛道',
    tagColor: '#FF6B9D',
    duration: '100课时',
    level: '入门→精通',
    img: 'https://readdy.ai/api/search-image?query=artificial%20intelligence%20neural%20network%20deep%20learning%20robot%20brain%20glowing%20pink%20neon%20futuristic%20technology%20AGI%20superintelligence%20dark%20background%20vibrant%20colorful%20doodle%20art%20style&width=600&height=340&seq=course-ai-v2&orientation=landscape',
    why: 'AI是当前最确定的技术革命，从ChatGPT到AGI，掌握AI将让你在任何行业都具备核心竞争力。',
    whatLearn: ['机器学习与深度学习基础', '大语言模型原理与微调', 'AI智能体设计与开发', 'AIGC内容生成技术', 'AI伦理与安全', 'AGI路径与超级智能展望'],
    career: ['AI工程师', 'AI产品经理', 'AIGC创作者', 'AI伦理研究员'],
    future2030: '2030年AGI初步实现，AI工程师将成为最高薪职业，年薪中位数超过100万',
    future2040: '2040年AI与人类协作成为主流工作模式，AI训练师和AI伦理师成为新兴职业',
    future2050: '2050年超级AI（ASI）出现，AI-人类协作将创造超越人类想象的文明成就',
    relations: ['元宇宙', '脑机接口', '量子计算', '机器人', '区块链'],
    modules: [
      { title: '模块一：AI基础理论', lessons: 20, desc: '机器学习、深度学习、强化学习的核心算法与数学基础' },
      { title: '模块二：大语言模型', lessons: 25, desc: 'Transformer架构、预训练、RLHF微调与提示工程实战' },
      { title: '模块三：AI智能体', lessons: 20, desc: 'Agent框架、工具调用、多智能体协作系统设计' },
      { title: '模块四：AIGC应用', lessons: 18, desc: '图像生成、视频生成、音乐生成的技术原理与商业应用' },
      { title: '模块五：AGI与未来', lessons: 17, desc: 'AGI路径分析、超级智能风险、AI治理与人类未来' },
    ],
  },
  {
    id: 'quantum',
    icon: 'ri-bubble-chart-line',
    color: '#00FFCC',
    title: '量子计算课',
    subtitle: 'Quantum Computing',
    tag: '深度前沿',
    tagColor: '#00FFCC',
    duration: '70课时',
    level: '进阶',
    img: 'https://readdy.ai/api/search-image?query=quantum%20computer%20qubits%20entanglement%20glowing%20teal%20cyan%20neon%20particles%20dark%20background%20futuristic%20technology%20education%20vibrant%20colorful%20doodle%20art%20style&width=600&height=340&seq=course-quantum-v2&orientation=landscape',
    why: '量子计算将在密码学、药物研发、AI训练等领域带来革命性突破，是未来20年最重要的底层技术之一。',
    whatLearn: ['量子力学基础与量子比特原理', '量子门与量子电路设计', '量子算法（Shor/Grover）', '量子纠错与容错计算', '量子密码学与QKD', '量子计算在AI与元宇宙中的应用'],
    career: ['量子算法工程师', '量子密码学专家', '量子软件开发者', '量子计算研究员'],
    future2030: '2030年量子计算云服务普及，量子工程师年薪将超过200万',
    future2040: '2040年量子互联网全球部署，量子安全成为国家战略核心',
    future2050: '2050年量子计算解决人类最复杂的科学问题，量子工程师将主导科学革命',
    relations: ['AI', '区块链', '元宇宙', '脑机接口', '密码学'],
    modules: [
      { title: '模块一：量子力学基础', lessons: 15, desc: '叠加态、纠缠、测量原理与量子比特的物理实现' },
      { title: '模块二：量子算法', lessons: 18, desc: 'Shor算法、Grover算法、量子傅里叶变换的原理与实现' },
      { title: '模块三：量子编程', lessons: 15, desc: 'Qiskit、Cirq、Q#的量子编程实战与量子电路优化' },
      { title: '模块四：量子密码学', lessons: 12, desc: 'BB84协议、量子密钥分发、后量子密码学标准' },
      { title: '模块五：量子应用前沿', lessons: 10, desc: '量子机器学习、量子化学模拟、量子金融的最新进展' },
    ],
  },
  {
    id: 'robot',
    icon: 'ri-robot-2-line',
    color: '#FF6B35',
    title: '人形机器人课',
    subtitle: 'Humanoid Robotics',
    tag: '爆发赛道',
    tagColor: '#FF6B35',
    duration: '75课时',
    level: '进阶',
    img: 'https://readdy.ai/api/search-image?query=humanoid%20robot%20futuristic%20orange%20neon%20glow%20mechanical%20human%20form%20AI%20embodied%20intelligence%20dark%20background%20vibrant%20colorful%20doodle%20art%20style%20education&width=600&height=340&seq=course-robot-v2&orientation=landscape',
    why: '人形机器人是AI与物理世界的结合点，特斯拉Optimus、Figure AI等已引发全球竞赛，这是未来10年最确定的万亿赛道。',
    whatLearn: ['机器人运动学与动力学', '具身智能与强化学习', '人形机器人感知系统', '人机交互设计', '机器人伦理与安全', '人形机器人商业应用场景'],
    career: ['机器人工程师', '具身AI研究员', '人机交互设计师', '机器人产品经理'],
    future2030: '2030年人形机器人进入家庭，相关工程师需求爆发，薪资溢价超过200%',
    future2040: '2040年人形机器人承担80%体力劳动，机器人伦理师成为最重要的新职业',
    future2050: '2050年人形机器人与AI深度融合，机器人-人类协作创造全新的文明形态',
    relations: ['AI', '脑机接口', '元宇宙', '量子计算', '材料科学'],
    modules: [
      { title: '模块一：机器人基础', lessons: 15, desc: '运动学、动力学、控制理论与机器人操作系统（ROS）' },
      { title: '模块二：具身智能', lessons: 20, desc: '强化学习、模仿学习、世界模型在机器人中的应用' },
      { title: '模块三：感知系统', lessons: 15, desc: '视觉感知、触觉传感、多模态融合与环境理解' },
      { title: '模块四：人机交互', lessons: 12, desc: '自然语言交互、情感计算、安全协作机器人设计' },
      { title: '模块五：商业应用', lessons: 13, desc: '工业、医疗、家庭、服务场景的人形机器人应用案例' },
    ],
  },
  {
    id: '3dprint',
    icon: 'ri-printer-line',
    color: '#81C784',
    title: '3D打印与制造',
    subtitle: '3D Printing & Advanced Manufacturing',
    tag: '制造革命',
    tagColor: '#81C784',
    duration: '55课时',
    level: '入门→进阶',
    img: 'https://readdy.ai/api/search-image?query=3D%20printing%20advanced%20manufacturing%20bioprinting%20organ%20printing%20green%20neon%20glow%20futuristic%20technology%20dark%20background%20vibrant%20colorful%20doodle%20art%20style%20education&width=600&height=340&seq=course-3dprint-v2&orientation=landscape',
    why: '3D打印正在颠覆制造业，从航空航天到生物医疗，从建筑到食品，3D打印将重塑每一个行业的生产方式。',
    whatLearn: ['3D打印技术原理与工艺对比', '生物3D打印与器官制造', '金属3D打印与航空应用', '建筑3D打印技术', '3D打印材料科学', '数字制造与工业4.0'],
    career: ['3D打印工程师', '生物制造研究员', '数字制造专家', '增材制造产品经理'],
    future2030: '2030年3D打印器官进入临床应用，3D打印建筑在全球普及',
    future2040: '2040年个性化制造成为主流，传统大规模制造业大幅萎缩',
    future2050: '2050年分子级3D打印实现，任何物质都可以按需制造',
    relations: ['AI', '量子计算', '生物科技', '材料科学', '元宇宙'],
    modules: [
      { title: '模块一：3D打印基础', lessons: 12, desc: 'FDM、SLA、SLS、DMLS等主流工艺的原理、优缺点与选型' },
      { title: '模块二：生物3D打印', lessons: 15, desc: '生物墨水、器官打印、组织工程的前沿技术与伦理' },
      { title: '模块三：工业应用', lessons: 13, desc: '航空航天、汽车、医疗器械的3D打印应用案例' },
      { title: '模块四：数字制造', lessons: 10, desc: '数字孪生、按需制造、分布式制造的商业模式' },
      { title: '模块五：未来展望', lessons: 5, desc: '分子制造、纳米打印、太空制造的技术路线与商业前景' },
    ],
  },
  {
    id: 'spatial',
    icon: 'ri-map-2-line',
    color: '#4FC3F7',
    title: '空间计算课',
    subtitle: 'Spatial Computing',
    tag: '苹果赛道',
    tagColor: '#4FC3F7',
    duration: '65课时',
    level: '进阶',
    img: 'https://readdy.ai/api/search-image?query=spatial%20computing%20augmented%20reality%20city%20digital%20overlay%20holographic%20information%20blue%20cyan%20neon%20dark%20background%20futuristic%20technology%20education%20vibrant%20colorful%20doodle%20art%20style&width=600&height=340&seq=course-spatial-v2&orientation=landscape',
    why: '苹果Vision Pro开启了空间计算时代，这是继PC、移动互联网之后的第三次计算平台革命，现在入场正当时。',
    whatLearn: ['空间计算平台架构（visionOS/ARKit）', '三维空间交互设计', '空间锚点与持久化AR', '空间音频与触觉反馈', '空间计算应用开发', '空间计算商业场景'],
    career: ['空间计算开发者', 'visionOS应用设计师', '空间UX设计师', '空间计算产品经理'],
    future2030: '2030年空间计算设备普及率超过30%，相关开发者需求爆发',
    future2040: '2040年空间计算与物理世界完全融合，空间设计师成为最重要的创意职业',
    future2050: '2050年空间计算消失于无形，数字与物理的边界彻底消融',
    relations: ['元宇宙', 'AI', '6G网络', 'XR技术', '脑机接口'],
    modules: [
      { title: '模块一：空间计算基础', lessons: 12, desc: '空间计算的定义、历史、主流平台与技术架构' },
      { title: '模块二：visionOS开发', lessons: 18, desc: 'SwiftUI、RealityKit、ARKit的空间应用开发实战' },
      { title: '模块三：空间交互设计', lessons: 15, desc: '眼动追踪、手势识别、语音交互的空间UX设计原则' },
      { title: '模块四：空间内容创作', lessons: 12, desc: '3D内容制作、空间视频、全息影像的创作工具与流程' },
      { title: '模块五：商业应用', lessons: 8, desc: '零售、医疗、教育、工业的空间计算应用案例' },
    ],
  },
];

const comprehensiveCourse = {
  title: '前沿科技综合大师课',
  subtitle: 'Frontier Technology Master Program',
  color: '#FF6B9D',
  duration: '200课时',
  desc: '整合元宇宙、AI、区块链、量子计算、脑机接口、人形机器人、3D打印、空间计算、星链与低空经济等所有前沿科技，构建完整的未来科技认知体系与跨领域创新能力。',
  modules: [
    { title: '第一阶段：前沿科技全景', weeks: '1-4周', desc: '系统梳理所有前沿科技的底层逻辑、发展现状与未来路径，建立完整的技术认知地图' },
    { title: '第二阶段：技术交叉融合', weeks: '5-10周', desc: '深度探索各技术之间的协同效应：AI+量子、元宇宙+脑机接口、区块链+AI等跨领域融合' },
    { title: '第三阶段：未来场景设计', weeks: '11-16周', desc: '基于2030/2040/2050时间轴，设计未来生活、工作、娱乐、医疗、教育的完整场景方案' },
    { title: '第四阶段：创业与投资', weeks: '17-22周', desc: '前沿科技创业机会识别、商业模式设计、融资策略与投资逻辑的系统训练' },
    { title: '第五阶段：综合项目', weeks: '23-28周', desc: '独立完成一个跨领域的前沿科技项目，整合至少三个技术领域，形成完整的产品方案' },
  ],
  universityFuture: [
    {
      year: '2030',
      title: '大学专业第一次颠覆',
      changes: [
        '传统计算机科学→AI工程学、量子计算学、元宇宙工程学',
        '传统医学→数字医疗学、基因工程学、神经工程学',
        '传统商学→数字经济学、Web3商业学、元宇宙运营学',
        '传统设计→空间计算设计、XR体验设计、数字孪生设计',
        '新增专业：脑机接口工程、低空经济管理、量子密码学',
      ],
    },
    {
      year: '2040',
      title: '大学专业第二次颠覆',
      changes: [
        '意识工程学：研究人类意识数字化与脑机接口的融合',
        '星际经济学：研究太阳系内的资源开发与经济体系',
        '数字永生伦理学：研究意识上传的伦理、法律与社会影响',
        '人机协作设计：研究人类与AI/机器人的最优协作模式',
        '量子生物学：研究量子效应在生命系统中的应用',
      ],
    },
    {
      year: '2050',
      title: '大学专业第三次颠覆',
      changes: [
        '宇宙文明学：研究人类作为多星球文明的发展战略',
        '意识哲学工程：研究数字意识的本质与存在意义',
        '超级AI协作学：研究人类与ASI的共生关系与协作框架',
        '跨维度设计：设计物理与数字完全融合世界的体验',
        '文明可持续学：研究技术奇点后人类文明的可持续发展',
      ],
    },
  ],
};

export default function FrontierTraining() {
  const [activeCourse, setActiveCourse] = useState(courses[0]);
  const [activeTab, setActiveTab] = useState<'overview' | 'modules' | 'future'>('overview');
  const [showComprehensive, setShowComprehensive] = useState(false);
  const { ref: headerRef, isVisible: headerVisible } = useScrollAnimation();
  const { ref: contentRef, isVisible: contentVisible } = useScrollAnimation({ threshold: 0.05 });

  return (
    <section id="training" className="relative py-24 md:py-32 overflow-hidden" style={{ background: '#060A0F' }}>
      {/* Doodle background */}
      <div className="absolute inset-0 pointer-events-none overflow-hidden">
        <div className="absolute inset-0 opacity-3" style={{
          backgroundImage: 'linear-gradient(rgba(0,255,136,0.06) 1px, transparent 1px), linear-gradient(90deg, rgba(0,255,136,0.06) 1px, transparent 1px)',
          backgroundSize: '50px 50px',
        }} />
        <div className="absolute top-20 right-20 w-64 h-64 rounded-full opacity-6" style={{ background: `radial-gradient(ellipse, ${activeCourse.color}40 0%, transparent 70%)`, transition: 'background 0.5s' }} />
        <div className="absolute bottom-20 left-20 w-48 h-48 rounded-full opacity-6" style={{ background: 'radial-gradient(ellipse, #FFD70030 0%, transparent 70%)' }} />
        <svg className="absolute top-0 left-0 w-full" height="6" viewBox="0 0 1440 6" preserveAspectRatio="none">
          <path d="M0,3 Q90,0 180,3 Q270,6 360,3 Q450,0 540,3 Q630,6 720,3 Q810,0 900,3 Q990,6 1080,3 Q1170,0 1260,3 Q1350,6 1440,3" stroke="#00FF88" strokeWidth="1.5" fill="none" strokeOpacity="0.25"/>
        </svg>
      </div>

      <div className="relative z-10 max-w-[1400px] mx-auto px-6 md:px-10">
        {/* Header */}
        <div
          ref={headerRef as React.RefObject<HTMLDivElement>}
          className={`text-center mb-14 transition-all duration-700 ${headerVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
        >
          <div
            className="inline-flex items-center gap-2 px-5 py-2 mb-6"
            style={{
              border: '1.5px dashed rgba(255,255,255,0.25)',
              borderRadius: '50% 45% 55% 50% / 50% 55% 45% 50%',
            }}
          >
            <i className="ri-graduation-cap-line text-white/50 text-sm" />
            <span className="text-white/50 text-xs font-bold tracking-widest uppercase" style={{ fontFamily: 'Caveat, cursive' }}>Frontier Technology Training</span>
          </div>
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-black text-white mb-5" style={{ fontFamily: 'Orbitron, sans-serif' }}>
            前沿科技
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#00FF88] via-[#FFD700] to-[#FF6B9D]"> 培训体系</span>
          </h2>
          <p className="text-white/40 text-base max-w-3xl mx-auto leading-relaxed">
            系统化覆盖所有前沿科技领域，每门课程都基于未来20-30年的科技发展进行设计，
            让你在技术奇点到来之前，成为数字文明的先行者
          </p>
        </div>

        {/* Course Selector Grid */}
        <div className="grid grid-cols-3 sm:grid-cols-5 lg:grid-cols-9 gap-2 mb-10">
          {courses.map((course) => (
            <button
              key={course.id}
              onClick={() => { setActiveCourse(course); setActiveTab('overview'); }}
              className="flex flex-col items-center gap-2 p-3 transition-all duration-300 cursor-pointer"
              style={{
                background: activeCourse.id === course.id ? `${course.color}15` : 'rgba(255,255,255,0.03)',
                border: `1.5px solid ${activeCourse.id === course.id ? course.color + '60' : 'rgba(255,255,255,0.08)'}`,
                borderRadius: '50% 45% 55% 50% / 50% 55% 45% 50%',
              }}
            >
              <div
                className="w-8 h-8 flex items-center justify-center"
                style={{
                  background: activeCourse.id === course.id ? `${course.color}25` : 'rgba(255,255,255,0.05)',
                  borderRadius: '50% 40% 60% 45% / 45% 60% 40% 55%',
                }}
              >
                <i className={`${course.icon} text-sm`} style={{ color: activeCourse.id === course.id ? course.color : 'rgba(255,255,255,0.3)' }} />
              </div>
              <span
                className="text-xs font-semibold text-center leading-tight"
                style={{
                  color: activeCourse.id === course.id ? course.color : 'rgba(255,255,255,0.35)',
                  fontFamily: 'Caveat, cursive',
                  fontSize: '0.75rem',
                }}
              >
                {course.title.replace('课', '').replace('与', '/')}
              </span>
            </button>
          ))}
        </div>

        {/* Course Detail */}
        <div
          ref={contentRef as React.RefObject<HTMLDivElement>}
          className={`transition-all duration-700 ${contentVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
        >
          <div className="flex flex-col lg:flex-row gap-8 mb-10">
            {/* Course Image */}
            <div className="lg:w-96 flex-shrink-0">
              <div className="relative rounded-2xl overflow-hidden" style={{ border: `2px solid ${activeCourse.color}30` }}>
                <img src={activeCourse.img} alt={activeCourse.title} className="w-full h-56 object-cover object-top" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 to-transparent" />
                <div className="absolute bottom-4 left-4 right-4">
                  <div className="flex items-center gap-2 mb-2 flex-wrap">
                    <span
                      className="text-xs font-bold px-3 py-1"
                      style={{
                        color: activeCourse.tagColor,
                        background: `${activeCourse.tagColor}20`,
                        border: `1px solid ${activeCourse.tagColor}40`,
                        borderRadius: '50% 45% 55% 50% / 50% 55% 45% 50%',
                        fontFamily: 'Caveat, cursive',
                      }}
                    >
                      {activeCourse.tag}
                    </span>
                    <span className="text-white/50 text-xs">{activeCourse.duration}</span>
                    <span className="text-white/50 text-xs">{activeCourse.level}</span>
                  </div>
                  <h3 className="text-white font-black text-xl" style={{ fontFamily: 'Orbitron, sans-serif' }}>{activeCourse.title}</h3>
                  <p className="text-white/50 text-xs">{activeCourse.subtitle}</p>
                </div>
              </div>

              {/* Why Learn */}
              <div
                className="mt-4 p-5"
                style={{
                  background: `${activeCourse.color}08`,
                  border: `1.5px solid ${activeCourse.color}25`,
                  borderRadius: '14px 10px 14px 10px / 10px 14px 10px 14px',
                }}
              >
                <p className="text-xs font-bold mb-2" style={{ color: activeCourse.color, fontFamily: 'Caveat, cursive', fontSize: '0.9rem' }}>✦ 为什么要学？</p>
                <p className="text-white/55 text-xs leading-relaxed">{activeCourse.why}</p>
              </div>

              {/* Related Tech */}
              <div className="mt-4">
                <p className="text-white/30 text-xs font-bold tracking-widest uppercase mb-3">关联前沿科技</p>
                <div className="flex flex-wrap gap-2">
                  {activeCourse.relations.map((r) => (
                    <span
                      key={r}
                      className="text-xs px-3 py-1"
                      style={{
                        color: 'rgba(255,255,255,0.5)',
                        border: '1px solid rgba(255,255,255,0.12)',
                        borderRadius: '50% 45% 55% 50% / 50% 55% 45% 50%',
                        fontFamily: 'Caveat, cursive',
                      }}
                    >
                      {r}
                    </span>
                  ))}
                </div>
              </div>
            </div>

            {/* Course Content */}
            <div className="flex-1">
              {/* Tabs */}
              <div className="flex gap-1 p-1 mb-6 w-fit" style={{ background: 'rgba(255,255,255,0.04)', borderRadius: '50px' }}>
                {[
                  { id: 'overview', label: '课程概览' },
                  { id: 'modules', label: '课程大纲' },
                  { id: 'future', label: '未来应用' },
                ].map((tab) => (
                  <button
                    key={tab.id}
                    onClick={() => setActiveTab(tab.id as 'overview' | 'modules' | 'future')}
                    className="px-5 py-2 text-sm font-semibold transition-all duration-300 whitespace-nowrap cursor-pointer"
                    style={{
                      background: activeTab === tab.id ? activeCourse.color : 'transparent',
                      color: activeTab === tab.id ? '#000' : 'rgba(255,255,255,0.4)',
                      borderRadius: '50px',
                      fontFamily: activeTab === tab.id ? 'Caveat, cursive' : 'inherit',
                      fontSize: activeTab === tab.id ? '1rem' : '0.875rem',
                    }}
                  >
                    {tab.label}
                  </button>
                ))}
              </div>

              {activeTab === 'overview' && (
                <div className="flex flex-col gap-5">
                  {/* What to Learn */}
                  <div>
                    <p className="text-white/50 text-xs font-bold tracking-widest uppercase mb-3">学什么</p>
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
                      {activeCourse.whatLearn.map((item, i) => (
                        <div key={i} className="flex items-start gap-2">
                          <div
                            className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5"
                            style={{
                              background: `${activeCourse.color}20`,
                              borderRadius: '50% 40% 60% 45% / 45% 60% 40% 55%',
                            }}
                          >
                            <i className="ri-check-line text-xs" style={{ color: activeCourse.color }} />
                          </div>
                          <span className="text-white/60 text-sm">{item}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                  {/* Career */}
                  <div>
                    <p className="text-white/50 text-xs font-bold tracking-widest uppercase mb-3">学完能做什么</p>
                    <div className="flex flex-wrap gap-2">
                      {activeCourse.career.map((c) => (
                        <span
                          key={c}
                          className="text-sm px-4 py-2"
                          style={{
                            background: `${activeCourse.color}12`,
                            border: `1.5px solid ${activeCourse.color}30`,
                            borderRadius: '50% 45% 55% 50% / 50% 55% 45% 50%',
                            color: activeCourse.color,
                            fontFamily: 'Caveat, cursive',
                            fontSize: '0.9rem',
                          }}
                        >
                          {c}
                        </span>
                      ))}
                    </div>
                  </div>
                </div>
              )}

              {activeTab === 'modules' && (
                <div className="flex flex-col gap-3">
                  {activeCourse.modules.map((mod, i) => (
                    <div
                      key={i}
                      className="flex gap-4 p-4"
                      style={{
                        background: 'rgba(255,255,255,0.03)',
                        border: '1px solid rgba(255,255,255,0.08)',
                        borderRadius: '12px 8px 14px 10px / 10px 14px 8px 12px',
                      }}
                    >
                      <div
                        className="w-8 h-8 flex items-center justify-center flex-shrink-0 font-black text-sm"
                        style={{
                          background: `${activeCourse.color}20`,
                          borderRadius: '50% 40% 60% 45% / 45% 60% 40% 55%',
                          color: activeCourse.color,
                          fontFamily: 'Orbitron, sans-serif',
                        }}
                      >
                        {i + 1}
                      </div>
                      <div className="flex-1">
                        <div className="flex items-center gap-3 mb-1 flex-wrap">
                          <p className="text-white font-semibold text-sm">{mod.title}</p>
                          <span className="text-white/30 text-xs">{mod.lessons}课时</span>
                        </div>
                        <p className="text-white/45 text-xs leading-relaxed">{mod.desc}</p>
                      </div>
                    </div>
                  ))}
                </div>
              )}

              {activeTab === 'future' && (
                <div className="flex flex-col gap-4">
                  {[
                    { year: '2030', text: activeCourse.future2030, color: '#FF6B35' },
                    { year: '2040', text: activeCourse.future2040, color: '#A855F7' },
                    { year: '2050', text: activeCourse.future2050, color: '#00FFCC' },
                  ].map((f) => (
                    <div
                      key={f.year}
                      className="flex gap-4 p-5"
                      style={{
                        background: `${f.color}08`,
                        border: `1.5px solid ${f.color}25`,
                        borderRadius: '14px 10px 14px 10px / 10px 14px 10px 14px',
                      }}
                    >
                      <div
                        className="flex-shrink-0 font-black text-lg"
                        style={{ color: f.color, fontFamily: 'Orbitron, sans-serif', minWidth: '48px' }}
                      >
                        {f.year}
                      </div>
                      <p className="text-white/60 text-sm leading-relaxed">{f.text}</p>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>

          {/* Comprehensive Course CTA */}
          <div
            className="p-8 cursor-pointer transition-all duration-300"
            style={{
              background: 'linear-gradient(135deg, rgba(255,107,157,0.08) 0%, rgba(255,215,0,0.05) 50%, rgba(0,255,136,0.08) 100%)',
              border: '2px dashed rgba(255,107,157,0.4)',
              borderRadius: '20px 14px 20px 14px / 14px 20px 14px 20px',
            }}
            onClick={() => setShowComprehensive(!showComprehensive)}
          >
            <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
              <div>
                <div className="flex items-center gap-3 mb-3">
                  <div
                    className="w-12 h-12 flex items-center justify-center"
                    style={{
                      background: 'rgba(255,107,157,0.2)',
                      border: '2px solid rgba(255,107,157,0.5)',
                      borderRadius: '50% 40% 60% 45% / 45% 60% 40% 55%',
                    }}
                  >
                    <i className="ri-award-line text-[#FF6B9D] text-xl" />
                  </div>
                  <div>
                    <h3 className="text-white font-black text-xl" style={{ fontFamily: 'Orbitron, sans-serif' }}>{comprehensiveCourse.title}</h3>
                    <p className="text-white/40 text-sm">{comprehensiveCourse.subtitle} · {comprehensiveCourse.duration}</p>
                  </div>
                </div>
                <p className="text-white/50 text-sm leading-relaxed max-w-2xl">{comprehensiveCourse.desc}</p>
              </div>
              <div className="flex items-center gap-2 flex-shrink-0">
                <span className="text-[#FF6B9D] text-sm font-semibold" style={{ fontFamily: 'Caveat, cursive', fontSize: '1rem' }}>
                  {showComprehensive ? '收起详情' : '查看大学专业展望'}
                </span>
                <i className={`${showComprehensive ? 'ri-arrow-up-line' : 'ri-arrow-down-line'} text-[#FF6B9D]`} />
              </div>
            </div>

            {showComprehensive && (
              <div className="mt-8 grid grid-cols-1 md:grid-cols-3 gap-6">
                {comprehensiveCourse.universityFuture.map((uf) => (
                  <div
                    key={uf.year}
                    className="p-5"
                    style={{
                      background: 'rgba(0,0,0,0.3)',
                      border: '1px solid rgba(255,255,255,0.08)',
                      borderRadius: '14px 10px 14px 10px / 10px 14px 10px 14px',
                    }}
                  >
                    <p className="font-black text-2xl mb-1" style={{ color: uf.year === '2030' ? '#FF6B35' : uf.year === '2040' ? '#A855F7' : '#00FFCC', fontFamily: 'Orbitron, sans-serif' }}>{uf.year}</p>
                    <p className="text-white font-bold text-sm mb-4">{uf.title}</p>
                    <div className="flex flex-col gap-2">
                      {uf.changes.map((c, i) => (
                        <div key={i} className="flex items-start gap-2">
                          <span className="text-white/20 text-xs mt-0.5 flex-shrink-0">→</span>
                          <p className="text-white/45 text-xs leading-relaxed">{c}</p>
                        </div>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}
